import { Cpu } from 'lucide-react';
import StatusPill from '../common/StatusPill';
import { getServiceIcon, formatDate } from '../../fonctions/fonctions';
import './ServiceSection.css';

function mapServiceStatus(status) {
  const s = (status || '').toLowerCase();
  if (s === 'hors ligne')   return 'down';
  if (s === 'dégradé')      return 'degraded';
  if (s === 'opérationnel') return 'operational';
  return 'unknown';
}

function ServiceSection({ services }) {
  if (!services || !services.success) return null;

  return (
    <section className="service-section">

      <h2 className="section-title">
        <Cpu size={14} className="section-title-icon" />
        Services externes
      </h2>

      <div className="service-grid">
        {services.data.map(service => (
          <div key={service.service_name} className="service-card">

            <div className="service-card-left">
              <span className="service-icon-wrap">
                {getServiceIcon(service.service_name)}
              </span>
              <span className="service-name">{service.service_name}</span>
            </div>

            <div className="service-card-right">
              <StatusPill
                status={mapServiceStatus(service.service_status)}
                label={service.service_status}
                size="sm"
              />
              <span className="service-date">
                Vérif. {formatDate(service.service_last_udpate) || '—'}
              </span>
            </div>

          </div>
        ))}
      </div>

    </section>
  );
}

export default ServiceSection;
